/* Accordion */
var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function(ev) {
    closeAll(ev.target);
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}

function closeAll(tar) {
  var accs = document.querySelectorAll('.accordion');
  for (var i = 0; i < accs.length; i++) {
    if (accs[i] == tar) {
      continue;
    }
    accs[i].classList.remove('active');
    var panel = accs[i].nextElementSibling;
    panel.style.maxHeight = null;
  }
}



/* tabs */
jQuery(document).ready(function() {
    jQuery('ul.tabs-feature').each(function () {
      const links = jQuery(this).find('a');
      let active = links.first().addClass('active');
      let content = jQuery(active.attr('href'));
      links.not(':first').each(function () {
        jQuery(jQuery(this).attr('href')).hide();
      });
      jQuery(this).find('a').on('click', function (e) {
        active.removeClass('active');
        content.hide();
        active = jQuery(this);
        content = jQuery(jQuery(this).attr('href'));
        active.addClass('active');
        content.addClass('show');
        content.fadeIn();
        return false;
      });
    });

    /* PREORDER UPDATE */
    const productFormContainer = document.querySelector('#product-form-container');
    if (productFormContainer) {
        const isPreorder = productFormContainer.getAttribute('data-preorder') === 'true';
        const purchaseButton = document.querySelector('button#purchase');
    
        if (isPreorder && purchaseButton) {
            purchaseButton.innerText = 'PRE-ORDER NOW';
        }
    }
});





var carousel = document.querySelector('.carousel-body');
if(carousel !== null) {
  load_carousel(carousel);
}


function load_carousel(carousel) {
  var carousel = carousel; // document.querySelector('.carousel-body');
  var carouselContent = document.querySelector('.carousel-container');
  var slides = document.querySelectorAll('.carousel--item');
  var arrayOfSlides = Array.prototype.slice.call(slides);
  var carouselDisplaying;
  var screenSize;
  var lengthOfSlide;
  var maxSlides = 3;
  
  if(carousel !== null) {
    if(carousel.classList.contains('show-4')) {
      maxSlides = 4;
    }
  }
  setScreenSize();
  
  function addClone() {
     var lastSlide = carouselContent.lastElementChild.cloneNode(true);
     lastSlide.style.left = (-lengthOfSlide) + "px";
     carouselContent.insertBefore(lastSlide, carouselContent.firstChild);
  }
  // addClone();
  
  function removeClone() {
    var firstSlide = carouselContent.firstElementChild;
    firstSlide.parentNode.removeChild(firstSlide);
  }
  
  function moveSlidesRight() {
    var slides = document.querySelectorAll('.carousel--item');
    var slidesArray = Array.prototype.slice.call(slides);
    var width = 0;
  
    slidesArray.forEach(function(el, i){
      el.style.left = width + "px";
      width += lengthOfSlide;
    });
    addClone();
  }
  moveSlidesRight();
  
  function moveSlidesLeft() {
    var slides = document.querySelectorAll('.carousel--item');
    var slidesArray = Array.prototype.slice.call(slides);
    slidesArray = slidesArray.reverse();
    var maxWidth = (slidesArray.length - 1) * lengthOfSlide;
  
    slidesArray.forEach(function(el, i){
      maxWidth -= lengthOfSlide;
      el.style.left = maxWidth + "px";
    });
  }
  
  window.addEventListener('resize', setScreenSize);
  
  function setScreenSize() {
        console.log('MAX SLID:' + maxSlides);
  
    if(window.innerWidth >= 1024 && maxSlides == 4) {
      carouselDisplaying = maxSlides;
    }else if ( window.innerWidth >= 500 ) {
      carouselDisplaying = 3;
    } else if ( window.innerWidth >= 300 ) {
      carouselDisplaying = 1;
    } else {
      carouselDisplaying = 1;
    }
    getScreenSize();
  }
  
  function getScreenSize() {
    var slides = document.querySelectorAll('.carousel--item');
    var slidesArray = Array.prototype.slice.call(slides);
    if(carousel !== null) {
      lengthOfSlide = ( carousel.offsetWidth  / carouselDisplaying );
    } else {
      lengthofSlide = 0;
    }
    var initialWidth = -lengthOfSlide;
    slidesArray.forEach(function(el) {
      el.style.width = lengthOfSlide + "px";
      el.style.left = initialWidth + "px";
      initialWidth += lengthOfSlide;
    });
  }
  
  
  var rightNav = document.querySelector('.carousel-nav-right');
  rightNav.addEventListener('click', moveLeft);
  
  var moving = true;
  function moveRight() {
    if ( moving ) {
      moving = false;
      var lastSlide = carouselContent.lastElementChild;
      lastSlide.parentNode.removeChild(lastSlide);
      carouselContent.insertBefore(lastSlide, carouselContent.firstChild);
      removeClone();
      var firstSlide = carouselContent.firstElementChild;
      firstSlide.addEventListener('transitionend', activateAgain);
      moveSlidesRight();
    }
  }
  
  function activateAgain() {
    var firstSlide = carouselContent.firstElementChild;
    moving = true;
    firstSlide.removeEventListener('transitionend', activateAgain);
  }
  
  var leftNav = document.querySelector('.carousel-nav-left');
  leftNav.addEventListener('click', moveRight);
  
  // var moveLeftAgain = true;
  
  function moveLeft() {
    if ( moving ) {
      moving = false;
      removeClone();
      var firstSlide = carouselContent.firstElementChild;
      firstSlide.addEventListener('transitionend', replaceToEnd);
      moveSlidesLeft();
    }
  }
  
  function replaceToEnd() {
    var firstSlide = carouselContent.firstElementChild;
    firstSlide.parentNode.removeChild(firstSlide);
    carouselContent.appendChild(firstSlide);
    firstSlide.style.left = ( (arrayOfSlides.length -1) * lengthOfSlide) + "px";
    addClone();
    moving = true;
    firstSlide.removeEventListener('transitionend', replaceToEnd);
  }
  
  
  
  
  carouselContent.addEventListener('mousedown', seeMovement);
  
  var initialX;
  var initialPos;
  function seeMovement(e) {
    initialX = e.clientX;
    getInitialPos();
    carouselContent.addEventListener('mousemove', slightMove);
    document.addEventListener('mouseup', moveBasedOnMouse);
  }
  
  function slightMove(e) {
    if ( moving ) {
      var movingX = e.clientX;
      var difference = initialX - movingX;
      if ( Math.abs(difference) < (lengthOfSlide/4) ) {
        slightMoveSlides(difference);
      }  
    }
  }
  
  function getInitialPos() {
    var slides = document.querySelectorAll('.carousel--item');
    var slidesArray = Array.prototype.slice.call(slides);
    initialPos = [];
    slidesArray.forEach(function(el){
      var left = Math.floor( parseInt( el.style.left.slice(0, -2 ) ) ); 
      initialPos.push( left );
    });
  }
  
  function slightMoveSlides(newX) {
    var slides = document.querySelectorAll('.carousel--item');
    var slidesArray = Array.prototype.slice.call(slides);
    slidesArray.forEach(function(el, i){
      var oldLeft = initialPos[i];
      el.style.left = (oldLeft + newX) + "px";
    });
  }
  
  function moveBasedOnMouse(e) { 
    var finalX = e.clientX;
    if ( initialX - finalX > 0) {
      moveRight();
    } else if ( initialX - finalX < 0 ) {
      moveLeft();
    }
    document.removeEventListener('mouseup', moveBasedOnMouse);
    carouselContent.removeEventListener('mousemove', slightMove);
  }
}